import styled from 'styled-components'

import Inline from '../../../layout/Inline/Inline'

export const DataTableViewSelectorContainerStyled = styled(Inline)`
  background-color: ${props => props.theme.colors.white.base};
  padding: 0 ${props => props.theme.spacings.medium};
  height: 100%;
  max-width: 100%;
  flex-wrap: nowrap;
  overflow-x: auto;

  & > div {
    height: 100%;
  }
`
